import { getCurrentCountry } from './currentCountry'

export function updateCounterWishlist(counter) {
  localStorage.setItem(`SGH_WISHLISTITEMS_${getCurrentCountry()}`, counter)
}
